import React from 'react';
const problems = ['Spending hours every week planning lessons from scratch', 'Running out of activities and doing the same exercises repeatedly', 'Not knowing how to structure a full year of skill progression', 'Struggling to keep students engaged and motivated during class', 'Having no system to evaluate student development and report progress', 'Feeling unprepared before walking into the gym', 'Arriving at class without a clear plan in place', 'Constantly searching online for fresh new games and drills'];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-183">
      <div className="max-w-3xl mx-auto text-center" data-id="element-184">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0A0A0A] mb-10 tracking-tight leading-tight" data-id="element-185">
          If you teach PE, you are probably dealing with at least one of these
          problems:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-186">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-4 shadow-sm" data-id="element-187">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-188">❌</span>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-semibold leading-snug" data-id="element-189">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-190">
          What if all of this was already done for you?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#E5E5EA] to-transparent w-full" data-id="element-191" />
      </div>
    </section>;
}